import styles from "./style.module.css";

const Container = ({ children, className, ...props }) => {
  return (
    <div className={[styles.container, className].join(" ")} {...props}>
      {children}
    </div>
  );
};

export default Container;
